import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginCredentialsComponent } from './login-credentials.component';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {SharedModule} from "../../shared/shared.module";

@NgModule({
  declarations: [
    LoginCredentialsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    SharedModule
  ]
})
export class LoginCredentialsModule {}
